import {useQuery, UseQueryResult} from '@tanstack/react-query'

import {QueryKeyName, getYearlyDataPoints} from '../../common/backend'
import {YearlyDataPointsPayload, YearlyHierarchyAnalysisDataPoint} from '../../types'

export const useYearlyDataPoints = (
  params: YearlyDataPointsPayload,
  options?: {enabled?: boolean}
): UseQueryResult<YearlyHierarchyAnalysisDataPoint[]> => {
  return useQuery({
    queryKey: [QueryKeyName.GetYearlyDataPoints, params],
    queryFn: () => getYearlyDataPoints(params),
    staleTime: Infinity,
    enabled: options?.enabled
  })
}
